import React from 'react';

import Input from '../../../../../../form/Input';
import Select from '../../../../../../form/Select';
import DataList from '../../../../../../form/DataList';

import {
    Alert,
    CircularProgress,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Typography,
    Checkbox as MuiCheckbox,
    FormControlLabel,
} from '@mui/material';

import useCadastroRapidoProdutoXml from './useCadastroRapidoProdutoXml';
import EmbalagemXmlAutocomplete from './EmbalagemXmlAutocomplete';

export default function CadastroRapidoProdutoXml({
    open,
    onClose,

    itemXml,
    empresaId,
    parametro,
    onProdutoCriado,
    onCodigoVinculado,

    setFlashMessage,
}) {
    const STORAGE_CONFIRMAR_CADASTRO = 'movimento.xml.confirmarCadastroNovoProduto';
    const {
        dados,
        Grupo,
        SubGrupo,
        optionsGrupo,
        optionsSubGrupo,
        grupoLoading,
        subGrupoLoading,
        optionsEmbalagem,
        produtoSelecionado,
        embalagensProdutoExistente,
        conflitoCadastro,
        loading,
        produtosSemelhantes,
        loadingSemelhantes,
        actions,
    } = useCadastroRapidoProdutoXml({
        open,
        itemXml,
        empresaId,
        parametro,
        onProdutoCriado,
        onCodigoVinculado,
        setFlashMessage,
    });

    const codigoInformado = (value) => {
        const codigo = String(value ?? '').trim().toUpperCase();
        return codigo && !/^0+$/.test(codigo) && !['SEM GTIN', 'SEM GTIN TRIB'].includes(codigo);
    };
    const semGtinNoXml = !codigoInformado(dados?.gtinComercial) && !codigoInformado(dados?.gtinTributavel);
    const [confirmacaoCadastroAberta, setConfirmacaoCadastroAberta] = React.useState(false);

    const [confirmarCadastroNovo, setConfirmarCadastroNovo] = React.useState(() => {
        try {
            return localStorage.getItem(STORAGE_CONFIRMAR_CADASTRO) !== 'false';
        } catch {
            return true;
        }
    });

    const alterarConfirmacaoCadastro = (event) => {
        const confirmar = event.target.checked;

        setConfirmarCadastroNovo(confirmar);

        try {
            localStorage.setItem(STORAGE_CONFIRMAR_CADASTRO, String(confirmar));
        } catch {
            // O cadastro continua funcionando sem persistir a preferência.
        }
    };

    const solicitarCadastroNovo = () => {
        if (confirmarCadastroNovo) {
            setConfirmacaoCadastroAberta(true);
            return;
        }

        actions.cadastrarNovo?.();
    };

    const confirmarCadastro = () => {
        setConfirmacaoCadastroAberta(false);
        actions.cadastrarNovo?.();
    };
    return (
        <Dialog open={Boolean(open)} onClose={loading ? undefined : onClose} fullWidth maxWidth="lg">
            <DialogTitle>Cadastro rápido de produto pelo XML</DialogTitle>

            <DialogContent dividers>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            md: '1fr 1fr',
                        },
                        gap: 3,
                    }}
                >
                    {/* LADO ESQUERDO */}
                    <Box>
                        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
                            Dados para cadastro
                        </Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1.5,
                            }}
                        >
                            <Input
                                text="Descrição"
                                name="descricao"
                                value={dados?.descricao ?? ''}
                                handleOnChange={actions.change}
                                inputWidth="100%"
                                required
                            />

                            {dados?.carregandoNcm ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                    }}
                                >
                                    <CircularProgress size={18} />

                                    <Typography variant="body2">Localizando NCM...</Typography>
                                </Box>
                            ) : dados?.ncmNaoLocalizado ? (
                                <Alert severity="warning">
                                    NCM {dados?.ncmCodigo || 'não informado'} não localizado. Entre em contato com o suporte.
                                </Alert>
                            ) : dados?.ncm ? (
                                <Box
                                    sx={{
                                        p: 1.5,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        borderRadius: 1,
                                    }}
                                >
                                    <Typography variant="caption" color="text.secondary">
                                        NCM
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {dados.ncm.ncmFormatado ?? dados.ncm.ncm ?? dados.ncmCodigo}
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary">
                                        {dados.ncm.descricao ?? ''}
                                    </Typography>
                                </Box>
                            ) : null}

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: { xs: '1fr', sm: 'minmax(0, 1fr) minmax(0, 1fr)' },
                                    gap: 1.5,
                                }}
                            >
                                <Box sx={{ minWidth: 0 }}>
                                    <DataList
                                        text="Grupo"
                                        name="Grupo.descricao"
                                        title="Digite para pesquisar e selecione o grupo do novo produto"
                                        placeholder="Digite para pesquisar o Grupo"
                                        inputWidth="100%"
                                        filteredOptions={optionsGrupo}
                                        value={Grupo?.descricao || ''}
                                        handleOnChange={actions.change}
                                        readonly={loading || !dados?.empresaId}
                                    />
                                    {grupoLoading ? (
                                        <Typography variant="caption" color="text.secondary" role="status">
                                            Pesquisando grupos...
                                        </Typography>
                                    ) : Grupo?.descricao && !dados?.grupoId ? (
                                        <Typography variant="caption" color="warning.main">
                                            Selecione uma opção da lista ou limpe o campo.
                                        </Typography>
                                    ) : null}
                                </Box>

                                <Box sx={{ minWidth: 0 }}>
                                    <DataList
                                        text="Subgrupo"
                                        name="SubGrupo.descricao"
                                        title={
                                            dados?.grupoId
                                                ? 'Selecione um subgrupo do grupo informado'
                                                : 'Selecione primeiro o Grupo'
                                        }
                                        placeholder={
                                            !dados?.grupoId
                                                ? 'Selecione primeiro o Grupo'
                                                : subGrupoLoading
                                                  ? 'Carregando subgrupos...'
                                                  : optionsSubGrupo.length
                                                    ? 'Digite ou selecione o Subgrupo'
                                                    : 'Nenhum subgrupo cadastrado'
                                        }
                                        inputWidth="100%"
                                        filteredOptions={optionsSubGrupo}
                                        value={SubGrupo?.descricao || ''}
                                        handleOnChange={actions.change}
                                        readonly={loading || !dados?.grupoId || subGrupoLoading || !optionsSubGrupo.length}
                                    />
                                    {subGrupoLoading ? (
                                        <Typography variant="caption" color="text.secondary" role="status">
                                            Carregando subgrupos...
                                        </Typography>
                                    ) : SubGrupo?.descricao && !dados?.subGrupoId ? (
                                        <Typography variant="caption" color="warning.main">
                                            Selecione uma opção da lista ou limpe o campo.
                                        </Typography>
                                    ) : dados?.grupoId && !optionsSubGrupo.length ? (
                                        <Typography variant="caption" color="text.secondary">
                                            Nenhum subgrupo ativo disponível para este grupo.
                                        </Typography>
                                    ) : null}
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    p: 1.5,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                }}
                            >
                                <Typography fontWeight={600}>Classificação do novo produto</Typography>

                                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                                    Estas opções serão aplicadas somente ao cadastrar como novo.
                                </Typography>

                                <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
                                        gap: 0.5,
                                        '& .MuiFormControlLabel-root': { m: 0 },
                                    }}
                                >
                                    <FormControlLabel
                                        title="Este novo produto estará disponível para vendas"
                                        control={
                                            <MuiCheckbox
                                                name="venda"
                                                title="Este novo produto estará disponível para vendas"
                                                checked={!!dados?.venda}
                                                onChange={actions.change}
                                                disabled={loading}
                                            />
                                        }
                                        label="Disponível para venda"
                                    />

                                    <FormControlLabel
                                        title="Este novo produto é uma Matéria-Prima"
                                        control={
                                            <MuiCheckbox
                                                name="materiaPrima"
                                                title="Este novo produto é uma Matéria-Prima"
                                                checked={!!dados?.materiaPrima}
                                                onChange={actions.change}
                                                disabled={loading}
                                            />
                                        }
                                        label="Matéria-prima"
                                    />

                                    <FormControlLabel
                                        title="Produto utilizado como embalagem"
                                        control={
                                            <MuiCheckbox
                                                name="embalagem"
                                                checked={!!dados?.embalagem}
                                                onChange={actions.change}
                                                disabled={loading}
                                            />
                                        }
                                        label="Embalagem"
                                    />

                                    <FormControlLabel
                                        title="Produto destinado ao uso e consumo"
                                        control={
                                            <MuiCheckbox
                                                name="usoConsumo"
                                                checked={!!dados?.usoConsumo}
                                                onChange={actions.change}
                                                disabled={loading}
                                            />
                                        }
                                        label="Uso e consumo"
                                    />
                                </Box>
                            </Box>
                            <Divider sx={{ my: 1 }} />

                            <Typography fontWeight={600}>Código de Barras Comercial</Typography>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: {
                                        xs: '1fr',
                                        sm: '1fr 1fr',
                                    },
                                    gap: 1.5,
                                    alignItems: 'end',
                                }}
                            >
                                <Input
                                    text="GTIN comercial"
                                    name="gtinComercial"
                                    placeholder="Digite ou leia o código"
                                    value={dados?.gtinComercial ?? ''}
                                    handleOnChange={actions.change}
                                />

                                <EmbalagemXmlAutocomplete
                                    text="Embalagem comercial"
                                    name="embalagemComercialId"
                                    options={optionsEmbalagem}
                                    value={dados?.embalagemComercialId ?? ''}
                                    handleOnChange={actions.change}
                                    disabled={loading}
                                />
                            </Box>
                            <Divider sx={{ my: 1 }} />

                            <Typography fontWeight={600}>Código de Barras Tributável</Typography>

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: {
                                        xs: '1fr',
                                        sm: '1fr 1fr',
                                    },
                                    gap: 1.5,
                                    alignItems: 'end',
                                }}
                            >
                                <Input
                                    text="GTIN tributável"
                                    name="gtinTributavel"
                                    placeholder="Digite ou leia o código"
                                    value={dados?.gtinTributavel ?? ''}
                                    handleOnChange={actions.change}
                                />

                                <EmbalagemXmlAutocomplete
                                    text="Embalagem tributável"
                                    name="embalagemTributavelId"
                                    options={optionsEmbalagem}
                                    value={dados?.embalagemTributavelId ?? ''}
                                    handleOnChange={actions.change}
                                    disabled={loading}
                                />
                            </Box>

                            {semGtinNoXml && (
                                <>
                                    <Divider sx={{ my: 1 }} />

                                    <Alert severity="info">
                                        O XML não possui GTIN. Ao cadastrar como novo será gerado um código interno.
                                        Para reaproveitar um cadastro, selecione um produto e sua embalagem no painel ao lado.
                                    </Alert>

                                    <EmbalagemXmlAutocomplete
                                        text="Embalagem padrão"
                                        name="embalagemPadraoId"
                                        options={optionsEmbalagem}
                                        value={dados?.embalagemPadraoId ?? ''}
                                        handleOnChange={actions.change}
                                        disabled={loading}
                                    />
                                </>
                            )}
                        </Box>
                    </Box>

                    {/* LADO DIREITO */}
                    <Box>
                        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
                            Produtos semelhantes
                        </Typography>

                        {conflitoCadastro.length > 0 && (
                            <Alert severity="warning" sx={{ mb: 2 }}>
                                Cadastro bloqueado por descrição ou código existente. Selecione o produto correto abaixo.
                                Produtos inativos precisam ser revisados no cadastro normal.
                            </Alert>
                        )}
                        {semGtinNoXml && produtoSelecionado?.id && (
                            <Box sx={{ mb: 2 }}>
                                <Alert severity="info" sx={{ mb: 1 }}>
                                    Use uma embalagem já vinculada a este produto. Esta ação não cria Produto nem código de barras.
                                </Alert>
                                <Select
                                    text="Embalagem do produto existente"
                                    name="produtoEmbalagemExistenteId"
                                    options={embalagensProdutoExistente}
                                    value={dados.produtoEmbalagemExistenteId ?? ''}
                                    handleOnChange={actions.change}
                                    notOptNull={false}
                                />
                                {embalagensProdutoExistente.length === 0 && (
                                    <Alert severity="warning">O produto não possui embalagem ativa utilizável. Revise seu cadastro.</Alert>
                                )}
                            </Box>
                        )}

                        {loadingSemelhantes ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    py: 2,
                                }}
                            >
                                <CircularProgress size={20} />

                                <Typography variant="body2">Procurando produtos semelhantes...</Typography>
                            </Box>
                        ) : produtosSemelhantes.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">
                                Nenhum produto semelhante localizado.
                            </Typography>
                        ) : (
                            produtosSemelhantes.map((produto) => {
                                const selecionado = Number(produtoSelecionado?.id) === Number(produto.id);

                                return (
                                    <Box
                                        key={produto.uuid ?? produto.id}
                                        onClick={() => actions.selecionarProduto(produto)}
                                        sx={{
                                            p: 1.5,
                                            mb: 1,

                                            border: '1px solid',

                                            borderColor: selecionado ? 'primary.main' : 'divider',

                                            borderRadius: 1,
                                            cursor: 'pointer',

                                            backgroundColor: selecionado ? 'action.selected' : 'transparent',
                                        }}
                                    >
                                        <Typography fontWeight={600}>{produto.descricao}</Typography>

                                        <Typography variant="body2">Código: {produto.codigo ?? '-'}</Typography>

                                        <Typography variant="body2" color="text.secondary">
                                            Grupo: {produto.Grupo?.descricao ?? '-'}
                                        </Typography>

                                        <Typography variant="body2" color="text.secondary">
                                            NCM: {produto.NCM?.ncmFormatado ?? produto.NCM?.ncm ?? '-'}
                                        </Typography>

                                        {produto.produtoEmbalagens?.map((produtoEmbalagem) => (
                                            <Typography
                                                key={produtoEmbalagem.id}
                                                variant="caption"
                                                display="block"
                                                color="text.secondary"
                                            >
                                                {produtoEmbalagem?.Embalagem?.descricao}
                                                {' — '}
                                                {produtoEmbalagem.codigoBarras}
                                                {produtoEmbalagem.principal ? ' — Principal' : ''}
                                            </Typography>
                                        ))}
                                    </Box>
                                );
                            })
                        )}
                    </Box>
                </Box>
            </DialogContent>

            <DialogActions
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                }}
            >
                {confirmacaoCadastroAberta ? (
                    <>
                        <Typography
                            variant="body2"
                            color="warning.main"
                            sx={{
                                flexGrow: 1,
                                fontWeight: 600,
                            }}
                        >
                            Confirma o cadastro de um novo produto? O sistema verificará duplicidades antes de gravar.
                        </Typography>

                        <Button onClick={() => setConfirmacaoCadastroAberta(false)} disabled={loading} color="inherit">
                            Voltar
                        </Button>

                        <Button variant="contained" color="warning" onClick={confirmarCadastro} disabled={loading}>
                            Sim, cadastrar novo
                        </Button>
                    </>
                ) : (
                    <>
                        <FormControlLabel
                            sx={{
                                marginRight: 'auto',
                            }}
                            control={
                                <MuiCheckbox checked={confirmarCadastroNovo} onChange={alterarConfirmacaoCadastro} size="small" />
                            }
                            label="Confirmar antes de cadastrar produto novo"
                        />

                        <Button onClick={onClose} disabled={loading} variant="contained" color="error">
                            Cancelar
                        </Button>

                        <Button variant="contained" color="warning" onClick={solicitarCadastroNovo} disabled={loading}>
                            {loading ? 'Processando...' : 'Cadastrar como novo'}
                        </Button>

                        <Button
                            variant="contained"
                            onClick={actions.vincularCodigo}
                            disabled={loading || !produtoSelecionado?.id || (semGtinNoXml && !dados.produtoEmbalagemExistenteId)}
                        >
                            {semGtinNoXml ? 'Usar produto selecionado' : 'Vincular produto selecionado'}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}
